const STYLES = {
  "On Sale": "bg-emerald-400/15 text-emerald-300 border-emerald-400/30",
  "Limited Availability": "bg-[#FF5A1E]/15 text-[#FF8A5B] border-[#FF5A1E]/40",
  "Sold Out": "bg-white/10 text-zinc-300 border-white/15",
  "Coming Soon": "bg-[#9D4EDD]/15 text-[#C9A0F0] border-[#9D4EDD]/40",
  Past: "bg-white/5 text-zinc-400 border-white/10",
};

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 font-mono text-[11px] uppercase tracking-wider ${STYLES[status] || STYLES.Past}`}>
    {status === "Limited Availability" && <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#FF5A1E]" />}
    {status}
  </span>
);
